<!--
  Kommerzielle Landingpage „Brotautomat & Backwarenautomat“ (Bündel
  brot+brötchen+backwaren). Eigener Winkel: Umsatz in Randzeiten (früh/sonntags)
  ohne Ladendienst. Referenz: Brotfreundin (Live-Link + Video) + echte Presse.
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🥖</div>
      <span class="lp-eyebrow" i18n="@@brot.hero.eyebrow">Backwaren · 24/7 · auch sonntags</span>
      <h1 class="title display" i18n="@@brot.hero.h1">Brotautomat &amp; Backwarenautomat</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@brot.hero.lead">
        Verkaufe Brot und Brötchen auch dann, wenn der Laden zu ist – früh morgens, sonntags und feiertags.
        Die <span class="tm">marktbox</span> holt den Umsatz aus den Randzeiten, ganz ohne zusätzlichen
        Ladendienst. Und du gönnst dir und deinen Mitarbeitern mehr Zeit für das, was wirklich zählt.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@brot.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#randzeiten" (click)="scrollTo($event, 'randzeiten')" i18n="@@brot.hero.ctaAnchor">Der Randzeiten-Trick ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Brotautomat mit frischen Backwaren rund um die Uhr" i18n-alt="@@brot.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@brot.hero.badge">🥐 frisch, auch am Sonntag</span>
    </figure>
  </div>
</section>

<!-- ===== Randzeiten-Argument (seiten-eigener Kern) ===== -->
<section id="randzeiten" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@brot.rz.h2">Der Umsatz liegt in den Randzeiten</h2>
    <p class="lp-intro reveal" i18n="@@brot.rz.intro">
      Die Nachfrage nach frischen Brötchen endet nicht mit dem Ladenschluss. Ein Backwarenautomat fängt
      genau die Zeiten ab, in denen sich Personal nicht lohnt – und bindet Kundschaft an deine Bäckerei.
    </p>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🌅</span>
        <h3 i18n="@@brot.card1.h3">Frühstück vor Ladenöffnung</h3>
        <p i18n="@@brot.card1.p">Frische Brötchen ab 6 Uhr – bevor die erste Verkäuferin überhaupt im Laden steht.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">📅</span>
        <h3 i18n="@@brot.card2.h3">Sonn- &amp; Feiertage</h3>
        <p i18n="@@brot.card2.p">Verkauf auch dann, wenn der Laden geschlossen ist – ohne Personalkosten oder Öffnungspflicht.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🏷️</span>
        <h3 i18n="@@brot.card3.h3">Hygienisch &amp; konform</h3>
        <p i18n="@@brot.card3.p">Jedes Produkt liegt geschützt im eigenen Fach – hygienisch und mit korrekter Kennzeichnung nach Deklarationspflicht.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">📍</span>
        <h3 i18n="@@brot.card4.h3">Standort-Flexibilität</h3>
        <p i18n="@@brot.card4.p">Vor der Filiale, am Ortsrand oder im Nachbardorf ohne eigene Filiale – die Box geht dorthin, wo Kundschaft ist.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Presse / Trust ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@brot.press.h2">Über die marktbox wird berichtet</h2>
    <p class="lp-intro reveal" i18n="@@brot.press.intro">Bäckereien und Regionalmedien zeigen, wie der Brotautomat in der Praxis läuft:</p>
    <nav class="lp-press reveal" aria-label="Presseberichte" i18n-aria-label="@@brot.press.aria">
      @for (p of press; track p.url) {
      <a [href]="p.url" target="_blank" rel="noopener">📰 {{ p.label }}</a>
      }
    </nav>
  </div>
</section>

<!-- ===== Video: Brotfreundin (Facade) ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide lp-media-grid">
    <div class="lp-video__text reveal">
      <span class="lp-eyebrow" i18n="@@brot.video.eyebrow">Aus der Praxis · Brotfreundin</span>
      <h2 class="lp-h2" i18n="@@brot.video.h2">Eine Bäckerin erzählt</h2>
      <p class="lp-lead" i18n="@@brot.video.lead">
        Die „Brotfreundin“ verkauft ihre Backwaren über die marktbox. Im Video zeigt sie, wie der
        Automat ihren Alltag verändert – und warum die Randzeiten den Unterschied machen.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@brot.video.cta">Automat konfigurieren</a>
      </div>
    </div>
    <div class="lp-video reveal">
      @if (!videoOpen) {
      <button type="button" class="lp-video__facade" [style.background-image]="'url(' + videoThumb + ')'"
        (click)="openVideo()" aria-label="Video abspielen: Brotfreundin über die marktbox" i18n-aria-label="@@brot.video.aria">
        <span class="lp-video__play"></span>
      </button>
      } @else {
      <iframe [src]="videoUrl!" title="marktbox – Brotfreundin über den Backwarenautomat" i18n-title="@@brot.video.title"
        allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>
      }
    </div>
  </div>
</section>

<!-- ===== Live-Link: Brotfreundin ===== -->
<section class="lp-section">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@brot.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@brot.live.h2">Sieh, welche Backwaren gerade da sind</h2>
      <p class="lp-lead" i18n="@@brot.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Deine Kundschaft sieht in Echtzeit, was noch im
        Automaten liegt – hier am Beispiel der Brotfreundin.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@brot.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@brot.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@brot.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@brot.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Brotfreundin: Echtzeit-Verfügbarkeit der Backwaren" i18n-title="@@brot.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@brot.live.cap">Live-Beispiel: Brotfreundin</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Zahlen (Segment-Durchschnitt, stellvertretend) ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@brot.stats.h2">Was ein Brotautomat bringt</h2>
    <div class="lp-stats reveal">
      <div class="lp-stat"><span class="lp-stat__n">400+</span><span class="lp-stat__l" i18n="@@brot.stat1.l">Automaten bereits bei Bäckereien im Einsatz</span></div>
      <div class="lp-stat"><span class="lp-stat__n">~2.700 €</span><span class="lp-stat__l" i18n="@@brot.stat2.l">Ø Umsatz pro marktbox &amp; Monat</span></div>
      <div class="lp-stat"><span class="lp-stat__n">24/7</span><span class="lp-stat__l" i18n="@@brot.stat3.l">Verkauf auch früh, sonntags &amp; feiertags</span></div>
    </div>
    <p class="lp-intro reveal" i18n="@@brot.stats.note">
      Am stärksten läuft die Box dort, wo sie nicht mit den eigenen Öffnungszeiten konkurriert – etwa
      auf dem Land ohne Bäckerei oder Supermarkt in der Nähe. (Durchschnittswerte, stellvertretend fürs Segment.)
    </p>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@brot.price.h2">Brotautomat kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@brot.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@brot.price.buyText">Einmalige Investition – ideal, wenn der Automat dauerhaft zur Bäckerei gehört.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@brot.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@brot.price.rentText">Planbare Kosten, niedrige Einstiegshürde – gut, um einen neuen Standort zu testen.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@brot.price.cta">Zum Shop – Backwarenautomat konfigurieren</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@brot.price.fine">
      Rechnet sich das für meine Bäckerei?
      <a [routerLink]="['/', links.blog, blogUmsatz]">Ratgeber: Umsatz steigern mit Verkaufsautomaten</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@brot.mod.h2">Passende Modelle</h2>
    <div class="lp-models">
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="lp-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Backwarenautomat mit 39 Fächern" i18n-alt="@@brot.mod39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@brot.mod39.text">39 Fächer – für Bäckereien mit breitem Sortiment und hohem Durchsatz.</p>
          <span class="lp-model__more" i18n="@@brot.mod39.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="lp-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Brotautomat mit 24 Fächern" i18n-alt="@@brot.mod24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@brot.mod24.text">24 Fächer – kompakter Einstieg für einen zusätzlichen Verkaufsstandort.</p>
          <span class="lp-model__more" i18n="@@brot.mod24.more">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@brot.faq.h2">Häufige Fragen zum Brotautomat</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="lp-fineprint reveal" i18n="@@brot.faq.fine">
      Mehr für Bäckereien:
      <a [routerLink]="['/', links.blog, blogBaeckerei]">Verkaufsautomat für Bäckereien</a> ·
      <a [routerLink]="['/', links.blog, blogBackwaren]">Verkaufsautomat für Backwaren</a>
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@brot.final.h2">Bereit für deinen Brotautomaten?</h2>
    <p class="lp-lead" i18n="@@brot.final.lead">Hol dir den Umsatz aus den Randzeiten – finde dein Modell und starte.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@brot.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
